import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { useFilterSize } from '../TableFilters.Filter.es.js';
import { useTableFilters } from '../useTableFilters/useTableFilters.es.js';

/**
 * By default resets all values back to initialValues if set.
 */ const FilterActionButton = ({ onClick, children, size, start, className, action, ...props })=>{
    const { clear, reset } = useTableFilters();
    const classSize = useFilterSize({
        size,
        start
    });
    const handleOnClick = useCallback((e)=>{
        onClick?.(e);
        switch(action){
            case 'reset':
                return reset();
            case 'clear':
                return clear();
        }
    }, [
        onClick,
        clear,
        reset,
        action
    ]);
    return jsx("div", {
        className: classNames(classSize, className),
        children: jsx(Button, {
            ...props,
            onClick: handleOnClick,
            children: children
        })
    });
};

export { FilterActionButton };
//# sourceMappingURL=ActionButton.es.js.map
